var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1719 1.93874C12.3436 1.10376 11.0119 1.10376 10.1836 1.93874L2.13617 10.03C1.94065 10.2324 1.82583 10.4714 1.79324 10.7158L1.79255 10.7209L1.35132 13.8416L3.89025 13.4808V13.467L4.45977 13.3911C4.70673 13.3581 4.93521 13.2436 5.10988 13.058L5.11608 13.0515L13.1725 4.95129L13.1737 4.95003C14.0014 4.12232 14.0041 2.77767 13.1719 1.93874ZM9.25229 1.01393C10.594 -0.33813 12.7621 -0.337978 14.1037 1.01439C15.4412 2.36273 15.4441 4.53507 14.1025 5.87744L14.1018 5.87813L6.05892 13.9647C5.81443 14.2224 5.52169 14.4175 5.20275 14.5438V14.6199L1.2526 15.1813L1.25054 15.1815C0.920771 15.2274 0.57153 15.1401 0.315136 14.8869C0.0572772 14.6321 -0.0342513 14.281 0.0111664 13.9449L0.0117019 13.9409L0.492618 10.5395C0.565372 9.99864 0.817062 9.50457 1.19686 9.11323L1.20244 9.10751L9.25229 1.01393Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8774 3.27641C12.1347 3.53172 12.1363 3.94724 11.8809 4.20449L10.7172 5.37697C10.4619 5.63422 10.0464 5.63579 9.78919 5.38049C9.53194 5.12518 9.53036 4.70964 9.78567 4.45239L10.9494 3.2799C11.2047 3.02265 11.6202 3.02109 11.8774 3.27641Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.90381 16.4141C8.90381 16.0516 9.1976 15.7578 9.56006 15.7578H14.6613C15.0237 15.7578 15.3176 16.0516 15.3176 16.4141C15.3176 16.7765 15.0237 17.0703 14.6613 17.0703H9.56006C9.1976 17.0703 8.90381 16.7765 8.90381 16.4141Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.ba24d024eb3cd704d297bee4b7e5acde.svg";
export { ForwardRef as ReactComponent };